<template>
  <component
    :is="href ? 'a' : 'div'"
    :href="href"
    target="_blank"
    class="ui-table-info-cell"
  >
    <span v-if="$slots['icon']" class="ui-table-info-cell__icon">
      <slot name="icon"></slot>
    </span>

    <span class="ui-table-info-cell__content">
      <slot></slot>
    </span>

    <span v-if="$slots['end']" class="ui-table-info-cell__end">
      <slot name="end"></slot>
    </span>

    <IconChevronDown v-if="href" class="ui-table-info-cell__arrow" />
  </component>
</template>

<script setup lang="ts">
import IconChevronDown from './icons/IconChevronDown.vue'

type Props = {
  href?: string
}

defineProps<Props>()
</script>

<style lang="scss">
@import '../styles/config';

.ui-table-info-cell {
  display: flex;
  align-items: center;
  min-height: 3rem;
  padding: 0.75rem;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  & + .ui-table-info-cell {
    border-left: 1px solid $gray-200;
  }

  @include media-breakpoint-up(md) {
    min-height: 4.25rem;
  }
}

.ui-table-info-cell__icon {
  display: block;
  margin-right: 0.5rem;

  svg {
    width: 1rem;
    height: 1rem;
  }

  @include media-breakpoint-up(md) {
    svg {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
}

.ui-table-info-cell__content {
  margin-right: auto;
}

.ui-table-info-cell__end {
  display: block;
  margin-left: 1.25rem;
}

.ui-table-info-cell__arrow {
  width: 1.25rem;
  height: 1.25rem;
  margin-left: 1.25rem;
  transform: rotate(-90deg);
}
</style>
